import {
  createColumn,
  formatNumericCell,
  getCommonBodyCellProps,
  getCommonFooterCellProps,
  getCommonHeadCellProps,
} from "./commonUtils";
import { formatNumber } from "../../../utils/dataCalculations";

export const getPositionsComparisonsColumns = (theme, globalFilter) => {
  const commonHeadCellProps = getCommonHeadCellProps(theme);
  const commonBodyCellProps = getCommonBodyCellProps(theme);
  const commonFooterCellProps = getCommonFooterCellProps(theme);

  const highlightMatch = (text, searchTerm) => {
    if (!searchTerm || !text) return text;
    const textStr = String(text);
    const searchStr = String(searchTerm);
    const regex = new RegExp(`(${searchStr})`, "gi");
    const parts = textStr.split(regex);
    return parts?.map((part, index) =>
      part.toLowerCase() === searchStr.toLowerCase() ? (
        <span
          key={index}
          style={{
            backgroundColor: theme.palette.warning.light,
            color: theme.palette.warning.contrastText,
            padding: "1px 2px",
            borderRadius: theme.shape.borderRadius * 0.5,
          }}
        >
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  return [
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "position_type",
      "Position Type",
      150,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          Cell: ({ cell }) => {
            const value = cell.getValue();
            return (
              <span
                style={{
                  color:
                    value === "Previous Day Qty"
                      ? theme.palette.error.main
                      : theme.palette.text.primary,
                  fontWeight: value === "Previous Day Qty" ? 600 : 400,
                }}
              >
                {value || "-"}
              </span>
            );
          },
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "StrategyType",
      "Strategy Type",
      150,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          Cell: ({ cell }) =>
            highlightMatch(cell.getValue() || "-", globalFilter),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "StrategyName",
      "Strategy Name",
      150,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          enableGrouping: true,
          Cell: ({ cell }) =>
            highlightMatch(cell.getValue() || "", globalFilter),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "SYMBOL",
      "Symbol",
      100,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          Cell: ({ cell }) =>
            highlightMatch(cell.getValue() || "-", globalFilter),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "security_name",
      "Security Name",
      160,
      "left",
      {
        body: {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        other: {
          Cell: ({ cell }) =>
            highlightMatch(cell.getValue() || "-", globalFilter),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "previous_eod_quantity",
      "Yesterday's EOD Qty",
      120,
      "right",
      {
        other: {
          Cell: ({ cell }) =>
            formatNumericCell(
              cell.getValue(),
              formatNumber,
              theme.palette.error.main,
              theme.palette.text.primary,
            ),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "sod_quantity",
      "Today's SOD Qty",
      120,
      "right",
      {
        other: {
          sortingFn: (rowA, rowB, columnId) => {
            const aValue = rowA.getValue(columnId);
            const bValue = rowB.getValue(columnId);
            if ((!aValue || aValue === "nan") && bValue && bValue !== "nan")
              return 1;
            if (aValue && aValue !== "nan" && (!bValue || bValue === "nan"))
              return -1;
            const a = !aValue || aValue === "nan" ? 0 : aValue;
            const b = !bValue || bValue === "nan" ? 0 : bValue;
            return a - b;
          },
          Cell: ({ cell }) =>
            formatNumericCell(
              cell.getValue(),
              formatNumber,
              theme.palette.error.main,
              theme.palette.text.primary,
            ),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "position_difference",
      "Difference",
      120,
      "right",
      {
        other: {
          Cell: ({ cell }) =>
            formatNumericCell(
              cell.getValue(),
              formatNumber,
              theme.palette.error.main,
              theme.palette.text.primary,
            ),
        },
      },
    ),
    createColumn(
      commonHeadCellProps,
      commonBodyCellProps,
      commonFooterCellProps,
      "absolute_difference",
      "Absolute Difference",
      120,
      "right",
      {
        other: {
          Cell: ({ cell }) =>
            formatNumericCell(
              cell.getValue(),
              formatNumber,
              theme.palette.error.main,
              theme.palette.text.primary,
            ),
        },
      },
    ),
  ];
};
